<template>
  <div id="dialog" v-if='theEditorShow'>
    <el-dialog title="备注" :visible.sync="theEditorShow" width="20%" style="margin-top: 10%;">
      <el-form :model="form" :rules="rules" ref="ruleForm">
        <el-form-item label="备注名" label-width="80px" prop="remark2">
          <el-input
            v-model="form.remark2"
            onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
            autocomplete="off"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="confire_btn" @click="submitForm('ruleForm')" size="small">确 定</el-button>
        <el-button
          @click="theEditorShow = false"
          size="small"
          style="margin-left: 10px;"
          type="TheCustom"
        >取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      rules: {
        remark2: [{ required: true, message: "请输入备注名", trigger: "blur" }]
      },
      theEditorShow:false,
      form:{remark2:''}
    };
  },
  methods: {
      //备注调用接口
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params={
              openid:this.openid,
              remark:this.form.remark2
            }
            fetch({
              url: "hcm//wechat/updateRemark",
              method: "post",
              params: params,
              noFormat: true,
              responseType: "text"
            }).then(result => {
              let res = JSON.parse(result);
              let {data}=res
              if(res.status == '10000'){
                this.theEditorShow = false
                this.$emit('theQuery')
              }
            })
          }
        });
      },
      changeShow(openid,remark2){
          this.theEditorShow=true
          this.openid=openid
          this.form.remark2=remark2
      }
  },
};
</script>

